import * as fromGenerated from '../../_generated';

export type AssistantsPageTab = 'createdByMe' | 'sharedWithMe';

export function filterAssistantsByTabs(
  allAssistants: fromGenerated.AssistantView[],
  userId: string | undefined,
): Record<AssistantsPageTab, fromGenerated.AssistantView[]> {
  const assistantsCreatedByUser: fromGenerated.AssistantView[] = [];
  const assistantsSharedWithUser: fromGenerated.AssistantView[] = [];

  for (const assistant of allAssistants) {
    if (userId && assistant.ownedBy === userId) {
      assistantsCreatedByUser.push(assistant);
    } else {
      // Every non-owned assistant in the list is one the user can access via
      // the access graph — i.e. shared with them.
      assistantsSharedWithUser.push(assistant);
    }
  }

  return {
    createdByMe: assistantsCreatedByUser,
    sharedWithMe: assistantsSharedWithUser,
  };
}

export const convertLangToAssistantLocale = (
  lang: string | undefined,
): fromGenerated.AssistantTranslationView.LocaleEnum => {
  if (lang === 'en' || lang === 'fr') {
    return lang;
  }
  return 'und';
};
